/**
 * Canonical site origin used for absolute URLs in JSON-LD and canonical
 * <link> tags. Falls back to yebonadi.com when the current window origin
 * looks like a preview/staging host so search engines always index the
 * production identity.
 */
export const SITE_ORIGIN = "https://yebonadi.com";

/** Returns the absolute URL for a given pathname. */
export function absoluteUrl(pathname = "/") {
  const clean = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${SITE_ORIGIN}${clean}`;
}

/**
 * Standard WebPage JSON-LD for a marketing page. `path` is the route path
 * (e.g. "/accused"), and the fields carry into structured search results.
 */
export function webPageSchema({ path, title, description, section = "Marketing" }) {
  const url = absoluteUrl(path);
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url,
    inLanguage: "en-US",
    isPartOf: {
      "@type": "WebSite",
      name: "YeboNadi",
      url: SITE_ORIGIN,
    },
    about: {
      "@type": "Thing",
      name: "YeboNadi evidence recording app",
    },
    publisher: {
      "@type": "Organization",
      name: "Simple Concepts LLC",
      url: SITE_ORIGIN,
    },
    articleSection: section,
  };
}

/**
 * BreadcrumbList JSON-LD. `crumbs` is [{ name, path }] top-to-current.
 */
export function breadcrumbSchema(crumbs = []) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      item: absoluteUrl(c.path),
    })),
  };
}

/** FAQPage JSON-LD from [{ q, a }] pairs. */
export function faqPageSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: {
        "@type": "Answer",
        text: typeof a === "string" ? a : "",
      },
    })),
  };
}
